export const useGuestToken = () => {
  // Use cookie to persist guest token across sessions
  const guestToken = useCookie<string | null>('mealz-guest-token', {
    default: () => null,
    maxAge: 60 * 60 * 24 * 30, // 30 days
    path: '/',
    sameSite: 'lax'
  })

  // Generate a new guest token
  const generateGuestToken = (): string => {
    // Generate a random token (you might want to use a more sophisticated method)
    const token =
      Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15)
    guestToken.value = token
    return token
  }

  // Get current guest token or generate a new one
  const getGuestToken = (): string => {
    if (guestToken.value === null || guestToken.value.length === 0) {
      const newToken = generateGuestToken()
      return newToken
    }
    return guestToken.value
  }

  // Clear guest token (useful for logout or cart reset)
  const clearGuestToken = (): void => {
    guestToken.value = null
  }

  // Check if we have a valid guest token
  const hasGuestToken = computed(() => guestToken.value !== null && guestToken.value.length > 0)

  return {
    guestToken: readonly(guestToken),
    generateGuestToken,
    getGuestToken,
    clearGuestToken,
    hasGuestToken
  }
}
